'use client'
import { useLanguage } from '../../hooks'
import { useTheme } from 'next-themes'
import Image, { type ImageProps } from 'next/image'
import { useEffect, useState } from 'react'

type LogoTypeBrandProps = Omit<ImageProps, 'src'> & {
  forceTheme?: 'light' | 'dark'
}

export const LogoTypeBrand = ({ ...props }: LogoTypeBrandProps) => {
  const [mounted, setMounted] = useState(false)
  const { resolvedTheme } = useTheme()
  const locale = useLanguage()
  const theme = props.forceTheme ?? resolvedTheme
  // useEffect only runs on the client, so now we can safely show the UI
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return <Image {...props} src={`/full-logo-${theme}-${locale}.svg`} priority />
}
